/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { whatsAppTemplateUpdate } from '../../axios/whatsAppTemplateUpdate'
import type {
	WhatsAppTemplateUpdateError,
	WhatsAppTemplateUpdatePathParams,
	WhatsAppTemplateUpdateRequest,
	WhatsAppTemplateUpdateResponse,
} from '../../types/WhatsAppTemplateUpdate'

export const whatsAppTemplateUpdateMutationKey = () =>
	[{ url: '/organisations/:organisationId/whatsapp-templates/:templateId' }] as const

export type WhatsAppTemplateUpdateMutationKey = ReturnType<typeof whatsAppTemplateUpdateMutationKey>

export type WhatsAppTemplateUpdateVariables = {
	organisationId: WhatsAppTemplateUpdatePathParams['organisationId']
	templateId: WhatsAppTemplateUpdatePathParams['templateId']
	data: WhatsAppTemplateUpdateRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppTemplateController.php WhatsAppTemplateController::update */
export function useWhatsAppTemplateUpdate<TContext = unknown>(
	options?: UseMutationOptions<
		WhatsAppTemplateUpdateResponse,
		AxiosError<WhatsAppTemplateUpdateError>,
		WhatsAppTemplateUpdateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: whatsAppTemplateUpdateMutationKey(),
		mutationFn: ({ organisationId, templateId, data }: WhatsAppTemplateUpdateVariables) =>
			whatsAppTemplateUpdate(organisationId, templateId, data, config).then(res => res.data),
		...options,
	})
}
